import React, {useEffect, useState} from 'react';
import 'styles/login/basic/BasicSignIn.css';
import {useSessionConfiguration} from 'util/SessionConfigurationContext';

const UniversalOptionsList = ({
                                  options,
                                  onOptionClick,
                                  initialOption,
                                  optionalCurrentOption,
                                  isHeader = false,
                                  isOnWhiteBackground = false
                              }) => {
    const [hovered, setHovered] = useState('');
    const [activeTab, setActiveTab] = useState(initialOption || options[0]); // Use defaultOption or fallback to first option

    const {isDesktopView} = useSessionConfiguration();

    useEffect(() => {
        if (optionalCurrentOption) {
            setActiveTab(optionalCurrentOption);
        }
    }, [optionalCurrentOption]);

    const handleMouseEnter = (option) => setHovered(option);
    const handleMouseLeave = () => setHovered('');

    const handleClick = (option) => {
        setActiveTab(option);
        onOptionClick(option);
    };

    return (
        <div className="basic-sign-in-header">
            {options.map((option, index) => (
                <div
                    key={option}
                    className={`basic-sign-in-header-element 
                        ${index === 0 ? 'left' : (index === options.length - 1 ? 'right' : 'middle')} 
                        ${activeTab === option ? 'active' : hovered === option ? 'hovered-active' : ''}
                        ${(isDesktopView || !isHeader) ? '' : 'mobile'}
                        ${isHeader ? 'top-trending' : ''}
                    `}
                    onClick={() => handleClick(option)}
                    onMouseEnter={() => handleMouseEnter(option)}
                    onMouseLeave={handleMouseLeave}
                >
                    {option}
                </div>
            ))}
        </div>
    );
};

export default UniversalOptionsList;
